import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cb95816"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/index.vue
// module id = rxXL
// module chunks = 0